export enum ActivityStreamItemType {
  InformationChanged = 'InformationChanged',
  OtherEvent = 'OtherEvent',

  // Mercer
  ManagerChanged = 'ManagerChanged',
  StatusChanged = 'StatusChanged',
  PlanChanged = 'PlanChanged',
  ShortlistChanged = 'ShortlistChanged',
  ApproverChanged = 'ApproverChanged',

  // Org Planning
  // Position Events
  SetAsHeadPosition = 'SetAsHeadPosition',
  RemovedAsHeadPosition = 'RemovedAsHeadPosition',
  AssignedEmployee = 'AssignedEmployee',
  UnassignedEmployee = 'UnassignedEmployee',
  CreatedPosition = 'CreatedPosition',
  DeletedPosition = 'DeletedPosition',
  MovedPosition = 'MovedPosition',
  MovedPositionBetweenOrgCharts = 'MovedPositionBetweenOrgCharts',
  UpdatedPosition = 'UpdatedPosition',

  // Organisation Events
  ChangedInformation = 'ChangedInformation',
  CreatedOrganisation = 'CreatedOrganisation',
  UpdatedOrganisation = 'UpdatedOrganisation',
  DeletedOrganisation = 'DeletedOrganisation',
  OrganisationChanged = 'OrganisationChanged',
  MovedOrganisation = 'MovedOrganisation',
  MovedOrganisationBetweenOrgCharts = 'MovedOrganisationBetweenOrgCharts',
  CreatedOrganisationRecord = 'CreatedOrganisationRecord',
  UpdatedOrganisationRecord = 'UpdatedOrganisationRecord',
  DeletedOrganisationRecord = 'DeletedOrganisationRecord',
  CreatedEmployeeRole = 'CreatedEmployeeRole',
  UpdatedEmployeeRole = 'UpdatedEmployeeRole',
  DeletedEmployeeRole = 'DeletedEmployeeRole',
  EmployeeLineManagerUpdated = 'EmployeeLineManagerUpdated',

  // Employee Events
  MovedEmployeeBetweenOrgCharts = 'MovedEmployeeBetweenOrgCharts',
  AssignedPosition = 'AssignedPosition',
  UnassignedPosition = 'UnassignedPosition',

  // Season Events
  AutoApproveAllowedChanged = 'AutoApproveAllowedChanged',
  ApprovalRequiredChanged = 'ApprovalRequiredChanged',
  PayrollStateReset = 'PayrollStateReset',
  PayrollExported = 'PayrollExported',
  SeasonCompensationOverlaid = 'SeasonCompensationOverlaid',
  SeasonBenchmarkUpdateTriggered = 'SeasonBenchmarkUpdateTriggered',
  EmployeeSnapshotDataUpdated = 'EmployeeSnapshotDataUpdated',
  MercerDataTransferred = 'MercerDataTransferred',
  ReassignmentComparisonExecuted = 'ReassignmentComparisonExecuted',

  // Merit Letter Events
  LetterCreated = 'LetterCreated',
  LetterUpdated = 'LetterUpdated',
  LetterUnpublished = 'LetterUnpublished',
  LetterDeleted = 'LetterDeleted',

  // Merit Promotion Events
  PromotionRequested = 'PromotionRequested',
  PromotionDetailsUpdated = 'PromotionDetailsUpdated',
  PromotionRevoked = 'PromotionRevoked',
  PromotionRejected = 'PromotionRejected',
  PromotionSentForApproval = 'PromotionSentForApproval',
  PromotionFinalized = 'PromotionFinalized',
  PromotionReopened = 'PromotionReopened',
  PromotionReset = 'PromotionReset',

  // ECL Events
  TemplateVersionFooterTranslationChanged = 'FooterTranslationChanged',
  ReviewerChanged = 'ReviewerChanged',
  CreatedTemplate = 'CreatedTemplate',
  UpdatedTemplate = 'UpdatedTemplate',
  CreatedTemplateVersion = 'CreatedTemplateVersion',
  UpdatedTemplateVersion = 'UpdatedTemplateVersion',
  UpdatedTemplateVersionContent = 'UpdatedTemplateVersionContent',
  UpdatedTemplateVersionSettings = 'UpdatedTemplateVersionSettings',
  UpdatedTemplateVersionFooter = 'UpdatedTemplateVersionFooter',
  UpdatedTemplateVersionFooterTranslation = 'UpdatedTemplateVersionFooterTranslation',
  UpdatedTemplateVersionHeader = 'UpdatedTemplateVersionHeader',
  UpdatedTemplateVersionHeaderTranslation = 'UpdatedTemplateVersionHeaderTranslation',
  UpdatedTemplateVersionAcknowledgement = 'UpdatedTemplateVersionAcknowledgement',
  UpdatedTemplateVersionAcknowledgementTranslation = 'UpdatedTemplateVersionAcknowledgementTranslation',
  TemplateVersionSentToApprover = 'TemplateVersionSentToApprover',
  TemplateVersionApproved = 'TemplateVersionApproved',
  TemplateVersionRejected = 'TemplateVersionRejected',
  TemplateVersionRetired = 'TemplateVersionRetired',
  CreatedClause = 'CreatedClause',
  UpdatedClause = 'UpdatedClause',
  DeletedClause = 'DeletedClause',
  CreatedClauseVersion = 'CreatedClauseVersion',
  ClauseVersionSentToApprover = 'ClauseVersionSentToApprover',
  ClauseVersionApproved = 'ClauseVersionApproved',
  ClauseVersionRejected = 'ClauseVersionRejected',
  ClauseVersionRetired = 'ClauseVersionRetired',
  UpdatedClauseVersion = 'UpdatedClauseVersion',
  DeletedClauseVersion = 'DeletedClauseVersion',
  CreatedClauseTranslation = 'CreatedClauseTranslation',
  UpdatedClauseTranslation = 'UpdatedClauseTranslation',
  DeletedClauseTranslation = 'DeletedClauseTranslation',
  ApprovalWorkflowAborted = 'ApprovalWorkflowAborted',

  // Succession Management Events
  NewRecommendationAdded = 'NewRecommendationAdded',
  NewTalentAddedToPool = 'NewTalentAddedToPool',
  StateChanged = 'StateChanged',
  TalentRemovedFromPool = 'TalentRemovedFromPool',
  RevertedRecommendation = 'RevertedRecommendation',

  // InquiryApproval
  InquiryApprovalProposal = 'InquiryApprovalProposal',
  InquiryApprovalStep = 'InquiryApprovalStep',

  // Standing Position Evaluation
  MasterDataTransfer = 'MasterDataTransfer',
  EvaluationRequest = 'EvaluationRequest',
  MasterDataJobCode = 'MasterDataJobCode',
  MasterDataPositionClass = 'MasterDataPositionClass',
  MasterDataEmployee = 'MasterDataEmployee',

  // Authorization
  UserActivated = 'UserActivated',
  UserArchived = 'UserArchived',
  UserDeleted = 'UserDeleted',
  UserRoleAssigned = 'UserRoleAssigned',
  UserRoleUnassigned = 'UserRoleUnassigned',
  RuleBasedAccessFilterAssigned = 'RuleBasedAccessFilterAssigned',
  RuleBasedAccessFilterUnassigned = 'RuleBasedAccessFilterUnassigned',
  ClusterNodeAssigned = 'ClusterNodeAssigned',
  ClusterNodeUnassigned = 'ClusterNodeUnassigned',
  RoleCreated = 'RoleCreated',
  RoleUpdated = 'RoleUpdated',
  RoleDeleted = 'RoleDeleted',
  RolePermissionsGranted = 'RolePermissionsGranted',
  RolePermissionsRevoked = 'RolePermissionsRevoked',
  EndpointGroupCreated = 'EndpointGroupCreated',
  EndpointGroupUpdated = 'EndpointGroupUpdated',
  EndpointGroupDeleted = 'EndpointGroupDeleted',
  EndpointGroupCopied = 'EndpointGroupCopied'
}
